import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { Text } from '@fiverr-private/typography';
import { SearchIcon } from '@fiverr-private/visuals';
import {
    reportQuerySuggestionClick,
    reportQuerySuggestionImpression,
    type QuerySuggestionImpressionData,
} from '@fiverr-private/listing_events';
import { buildSuggestionSearchUrl } from '../../utils';
import { tagStyles, tagTextStyles } from './SuggestionTagItem.ve.css';

interface SuggestionTagItemProps {
    label: string;
    position: number;
}

export const SuggestionTagItem = ({ label, position }: SuggestionTagItemProps) => {
    const [impressionRef] = useImpressionItem({
        sendImpressionToBQ: false,
        onImpression: (impressionData: QuerySuggestionImpressionData) =>
            reportQuerySuggestionImpression({ label, position, impressionData }),
    });

    const onClick = () => {
        reportQuerySuggestionClick({ label, position });
    };

    return (
        <Stack
            as="a"
            ref={impressionRef}
            className={tagStyles}
            href={buildSuggestionSearchUrl(label)}
            onClick={onClick}
            backgroundColor="lightOrange_200"
            borderRadius="circle"
            paddingY="2.5"
            paddingX="3"
            color="lightOrange_1200"
            height="36px"
            alignItems="center"
            flexShrink="0"
        >
            <SearchIcon />
            <Text size="b_sm" as="span" fontWeight="semibold" className={tagTextStyles}>
                {label}
            </Text>
        </Stack>
    );
};
